import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, map, retry, tap } from "rxjs/operators";
import { AppService } from "src/app/app.service";
// import * as countries_data from "src/assets/json/countries.json";
import {
  TransformBusinessPipe,
  TransformSearchedUsersPipe,
  TransformUserPipe,
  TransformUsersPipe,
} from "../pipes/business.pipe";
import { Acl, Business, Course, Route, Team, User } from "../models/model";
import { stateRequest } from "../models/enum";
import { environment } from "src/environments/environment";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class TrainingService extends BaseService {
  public hasTabs: Boolean = false;
  public showModal: Boolean = false;
  public showFilterModal: Boolean = false;
  public showModalGroup: Boolean = false;
  public showModalGroupStudents: Boolean = false;
  public courseModal: any = { id: 0, name: 0 };
  public hiddenModal: Boolean = false;
  public hiddenFilterModal: Boolean = false;
  public hiddenModalGroup: Boolean = false;
  public hiddenModalGroupStudents: Boolean = false;
  public showLateralMenu: Boolean = false;

  public loading: Boolean = true;
  public permission: boolean = false;

  // Se le concede permiso a la empresa logueada
  public full: Boolean = false;

  conversations: Array<any> = [];

  public businessLambdaUrl = environment.urlAPIBusiness;
  public baseLambdaUrl = environment.urlAPI;

  public token: string;

  list_users: Array<any> = [];
  list_groups: Array<any> = [];

  user_asign: Array<any> = [];
  group_asign: Array<any> = [];

  list_asign_courses: Array<any> = [];
  list_asign_groups: Array<any> = [];
  set_list_asign: boolean;

  show_group_chat: boolean = false;

  baseRetry: number = 0;
  isOwner: boolean = false;
  constructor(http: HttpClient, _appService: AppService) {
    super(http, _appService);
  }

  /**
   * -1: No ha tenido respuesta de la busqueda de la petición
   * 0: No tiene empresa
   * 1: Tiene empresa
   */
  public stateGetBusiness: number = stateRequest.notExcuted;
  public businessInfo: Business[] = [];
  public _infoBusinessObservable: Subject<Business[]> = new Subject<
    Business[]
  >();
  public _infoBusiObservable: Subject<{ method: number; business: Business }> =
    new Subject<{ method: number; business: Business }>();
  public loadingBusiness: Boolean = true;
  public business: Business;

  userBusinessVerifyAccess(email = null): Observable<any> {
    const url = email
      ? `business/access/users?email=${email}`
      : `business/access`;

    return this.get(`${this.businessLambdaUrl}/${url}`).pipe(
      map((response: any) => response),
      retry(2),
      catchError(this.handleError<any>("getAccessBusiness", []))
    );
  }

  getBusiness(id?: any): Observable<any> {
    this.loadingBusiness = true;
    const url = id
      ? `${this.businessLambdaUrl}/business/"${id}"`
      : `${this.businessLambdaUrl}/business`;
    return this.get(url).pipe(
      map((response: any) => {
        const { status, data } = response;
        if (status) {
          const transformBusinessPipe = new TransformBusinessPipe();
          this.stateGetBusiness = stateRequest.excuted;

          this.businessInfo = transformBusinessPipe.transform(data);
          const ownerBusiness = this.businessInfo.find(
            (b) => b.owner_id == this._appService.user_data.id
          );
          this.business = ownerBusiness || this.businessInfo[0];
          if (this.businessInfo.length > 0) {
            this.isOwner =
              this._appService.user_data.id == this.business.owner_id;
          }

          this.loadingBusiness = false;


          return { valid: status, print: this.businessInfo };
        } else {
          this.stateGetBusiness = stateRequest.excuted;

          if (data.length > 0) {
            if (Object.keys(data[0]).length == 1) {
              this.businessInfo.push(data[0]);
              return { valid: status, print: this.businessInfo };
            }
          } else {
            return { valid: status, print: this.businessInfo };
          }
        }
        this.stateGetBusiness = stateRequest.error;
        this.loadingBusiness = false;
        return { valid: status, print: [] };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getBusiness", []))
    );
  }

  updateBusiness(id: any, data: any): Observable<any> {
    const url = `${this.businessLambdaUrl}/business/"${id}"`;
    return this.put(url, data).pipe(
      map((response: any) => {
        return { valid: response.status, print: response.data };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("putBusiness", []))
    );
  }

  createdBusinessObservable: Subject<any> = new Subject<any>();

  createBusiness(data: any): Observable<any> {
    const url = `${this.businessLambdaUrl}/business`;
    return this.post(url, data).pipe(
      map((response: any) => {
        let status = response?.status || false;
        let data = response?.data;
        if (status) {
          const transformBusinessPipe = new TransformBusinessPipe();
          this.businessInfo = transformBusinessPipe.transform([data]);
          this.stateGetBusiness = stateRequest.excuted;
          return { valid: status, print: this.businessInfo };
        }

        return { valid: status, print: data };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("postBusiness", []))
    );
  }

  deleteBusiness(id: any): Observable<any> {
    const url = `${this.businessLambdaUrl}/business/"${id}"`;
    return this.delete(url).pipe(
      map((response: any) => {
        return { valid: response.status, print: response.data };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("deleteBusiness", []))
    );
  }

  cleanBusiness() {
    this.business = null;
    this.businessInfo = [];
    this._infoBusinessObservable.next(this.businessInfo);
    this.stateGetBusiness = stateRequest.notExcuted;
    this.usersInfo = [];
    this._infoUsersObservable.next(this.usersInfo);
    this.stateGetUsers = stateRequest.notExcuted;
    this.isOwner = false;
    this.full = false;
  }

  // /business/{business_id}/file/{key}
  deleteBusinessFile(
    businessId: string,
    fileName: string,
    id?: string
  ): Observable<any> {
    const url = !id
      ? `${this.businessLambdaUrl}/business/"${businessId}"/file/"${fileName}"`
      : `${this.businessLambdaUrl}/business/"${businessId}"/groups/"${id}"/file/"${fileName}"`;
    return this.delete(url).pipe(
      map((response: any) => {
        return { valid: response.status, print: response.data };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("deleteBusinessFile", []))
    );
  }

  public coursesFromRoutes: Course[] = [];
  public filterByCourse: number;
  public filterByDepartment: any;

  public stateGetUsers: number = stateRequest.notExcuted;
  public usersInfo: Array<any> = [];
  public _infoUsersObservable: Subject<any[]> = new Subject<any[]>();
  public loadingUsers: Boolean = false;
  public _infoUserObservable: Subject<{ method: number; user: any }> =
    new Subject<{ method: number; user: any }>();

  getUsers(id: any): Observable<any> {
    this.loadingUsers = true;
    return this.get(`${this.businessLambdaUrl}/business/"${id}"/users`).pipe(
      map((response: any) => {
        const { status, data } = response;
        this.stateGetUsers = status ? stateRequest.excuted : stateRequest.error;
        if (status) {
          const usersPipe = new TransformUsersPipe();
          const tempUsers = usersPipe.transform(data);
          this.usersInfo = tempUsers;
          this._infoUsersObservable.next(this.usersInfo);
        }
        this.loadingUsers = false;
        return { valid: status, print: this.usersInfo };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getBusiness", []))
    );
  }

  addUsersBusiness(businessId: string, data: any): Observable<any> {
    const url = `${this.businessLambdaUrl}/business/"${businessId}"/users`;
    return this.post(url, data).pipe(
      map((response: any) => {
        const { status, data } = response;
        if (status) {
          const usersPipe = new TransformUserPipe();
          let tempUsers = [];
          let usersWithErrors = [];
          data.forEach((user) => {
            if (!user?.info_error) {
              const tempUser = usersPipe.transform(user);
              tempUsers.push(tempUser);
            } else {
              usersWithErrors.push(user);
            }
            this.usersInfo = Object.assign(
              [],
              this.usersInfo.concat(tempUsers)
            );
            this._infoUsersObservable.next(this.usersInfo);
          });
          return {
            valid: status,
            print: {
              users: tempUsers,
              usersWithErrors: usersWithErrors,
            },
          };
        }
        return { valid: response.status, print: response.data };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("addUserToBusiness", []))
    );
  }

  deleteUsersBusiness(businessId: string, user: User): Observable<any> {
    const url = `${this.businessLambdaUrl}/business/"${businessId}"/users/"${user.id}"`;
    return this.delete(url).pipe(
      map((response: any) => {
        const { status, data } = response;
        return { valid: status, print: user };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("deleteUserBusiness", []))
    );
  }

  public recommendedInfo: Array<any> = [];
  public loadingRecommended: Boolean = false;
  getRecommendedRelations(category_id): Observable<any> {
    return this.get(
      this.businessLambdaUrl + "/categories/recommended/" + category_id
    ).pipe(
      map((response: any) => {
        if (response.status) {
          this.recommendedInfo = response.data;
          //console.log("Training Service: this.recommendedRelations ", this.recommendedRelations);
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: response.data };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getRecommendedRelations", []))
    );
  }

  searchUsers(search_string: string, start: number): Observable<any> {
    return this.get(
      `${this.businessLambdaUrl}/business/"${this.business.id}"/users/search?search_string="${search_string}"&start=${start}`
    ).pipe(
      map((response: any) => {
        const { status, data } = response;
        if (status) {
          const usersPipe = new TransformSearchedUsersPipe();
          const tempUsers = usersPipe.transform(data);
          return { valid: true, print: tempUsers };
        } else {
          return { valid: false, print: [] };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("searchUsers", []))
    );
  }

  getRecommended(): Observable<any> {
    return this.get(this.businessLambdaUrl + "/recommendations").pipe(
      map((response: any) => {
        if (response.status) {
          console.log(
            "Training Service: getRecommended - response.data ",
            response.data
          );
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: response.data };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getRecommended", []))
    );
  }

  assingLicense(businessId: string, id: string, data: any): Observable<any> {
    const url = `${this.businessLambdaUrl}/business/"${businessId}"/users/"${id}"`;
    return this.put(url, data).pipe(
      map((response: any) => {
        return { valid: response.status, print: response.data };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("putRoute", []))
    );
  }

  // getRecommendedCourses(category_id): Observable<any> {
  //   return this
  //     .get(
  //       this.baseLambdaTrainingUrl + "/categories/" + category_id,
  //       this.getHeaders()
  //     )
  //     .pipe(
  //       map((response: any) => {
  //         const { status, data } = response;
  //         if (status) {
  //           const transformCoursePipe = new TransformCoursePipe();
  //           const tempCourses = transformCoursePipe.transform(data.cursos);

  //           // filter reppetead courses
  //           const tempCoursesFilter = [];
  //           tempCourses.forEach((course) => {
  //             const index = tempCoursesFilter.findIndex(
  //               (tempCourse) => tempCourse.id === course.id
  //             );
  //             if (index === -1) {
  //               tempCoursesFilter.push(course);
  //             }
  //           });
  //           return { valid: true, print: tempCoursesFilter };
  //         } else {
  //           return { valid: false, print: data };
  //         }
  //       }),
  //       retry(this.baseRetry),
  //       catchError(this.handleError<any>("getRecommendedSectures", []))
  //     );
  // }

  public progressInfoAll: Array<any> = [];
  public progress: Boolean = false;
  getProgressAll(): Observable<any> {
    return this.get(this.businessLambdaUrl + "/certifications/progress").pipe(
      map((response: any) => {
        if (response.status) {
          this.progress = true;
          this.progressInfoAll = response.data[0];
          //console.log("Training Service: getProgressAll - progressInfoAll ", this.progressInfoAll)
          return { valid: true, print: response.data[0] };
        } else {
          return { valid: false, print: response.data };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getProgressAll", []))
    );
  }

  public progressInfoUsers: Array<any> = [];
  getProgressUser(user_id): Observable<any> {
    return this.get(
      this.baseLambdaUrl + "/certifications/progress?user_id=" + user_id
    ).pipe(
      map((response: any) => {
        if (response.status) {
          this.progressInfoUsers.push(response.data[0]);
          //console.log("Training Service: getProgressUser - progressInfoUsers: ", this.progressInfoUsers)
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: response.data };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getProgressUser", []))
    );
  }

  checkPermission(
    userId: string,
    userAcls: Acl,
    teams: Team[],
    id?: string,
    type?: string
  ): boolean {
    // Obtener la lista de equipos
    // Verificar el ACL de cada equipo en la lista
    if (this.isOwner) {
      return true;
    }
    for (const team of teams) {
      if (team.users.some((user) => user.userId === userId)) {
        if (team.acl) {
          if (team.acl.type === "FULL") {
            return true;
          } else if (team.acl.type === "LIMITED") {
            if (team.acl.permitted[type]?.includes(id)) {
              return true;
            }
          }
        }
      }
    }

    // Verificar el ACL del usuario
    if (userAcls) {
      if (userAcls.type === "FULL") {
        return true;
      } else if (userAcls.type === "LIMITED") {
        if (userAcls.permitted[type]?.includes(id)) {
          return true;
        }
      }
    }
    return false;
  }

  public progressInfoGroups: Array<any> = [];
  getProgressGroups(group_id): Observable<any> {
    return this.get(
      this.businessLambdaUrl + "/teams/" + group_id + "/certifications/progress"
    ).pipe(
      map((response: any) => {
        if (response.status) {
          this.progressInfoGroups.push(response.data[0]);
          //console.log("Training Service: getProgressGroups - progressInfoGroups: ", this.progressInfoGroups)
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: response.data };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getProgressGroups", []))
    );
  }

  public getCertifications(): Observable<any> {
    return this.get(this.businessLambdaUrl + "/certifications").pipe(
      map((response: any) => {
        //console.log("response getCertifications - traininfService", response)
        if (response.status) {
          return { valid: true, print: response.data[0] };
        } else {
          return { valid: false, print: response };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getCertification", []))
    );
  }

  // public getCountries() {
  //   let countries: any = (countries_data as any).default;
  //   countries.shift(); //Eliminar el primer (internacional)
  //   let countries_data_response = [];
  //   let array_ = [];
  //   countries.forEach((element, index) => {
  //     if (index == countries.length - 1) {
  //       countries_data_response = countries.concat(array_);
  //       countries.sort((a: any, b: any) => {
  //         let countryA = a.id;
  //         let countryB = b.id;
  //         return countryA < countryB ? -1 : countryA > countryB ? 1 : 0;
  //       });
  //     }
  //   });
  //   return countries_data_response;
  // }

  conversationEdit(user_id, data, group_id): Observable<any> {
    return this.put(
      this.businessLambdaUrl + "/conversations/" + user_id,
      data
    ).pipe(
      map((response: any) => {
        if (response.status) {
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: response };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("conversationEdit", []))
    );
  }

  certificationEdit(id, data): Observable<any> {
    //console.log("link: ", this.baseLambdaTrainingUrl + "/certifications" + (id ? "/" + id : ""));
    //console.log("data", data);
    return this.put(
      this.businessLambdaUrl + "/certifications" + (id ? "/" + id : ""),
      data
    ).pipe(
      map((response: any) => {
        if (response.status) {
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: response.errorMessage };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("certificationEdit", []))
    );
  }

  businessEdit(id, data): Observable<any> {
    //console.log("Training Service: businessEdit - id ", id);
    //console.log("Training Service: businessEdit - data ", data);
    return this.put(this.businessLambdaUrl + "/business/" + id, data).pipe(
      map((response: any) => {
        if (response.status) {
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: response.errorMessage };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("TeamEdit", []))
    );
  }

  // DELETES
  userDelete(user_id): Observable<any> {
    return this.delete(this.businessLambdaUrl + "/students/" + user_id).pipe(
      map((response: any) => {
        // Validar datos
        if (response.status) {
          return { valid: true, print: response.Message };
        } else {
          return { valid: false, print: response.errorMessage };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("UserDelete", []))
    );
  }

  courseDelete(id): Observable<any> {
    return this.delete(this.businessLambdaUrl + "/courses/" + id).pipe(
      map((response: any) => {
        // Validar datos
        if (response.status) {
          return { valid: true, print: response.Message };
        } else {
          return { valid: false, print: response.errorMessage };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("CourseDelete", []))
    );
  }

  // getCourses(page): Observable<any> {
  //   return this
  //     .get(this.businessLambdaUrl + '/cursos?order_by="desc"&estado=[1,2]&page=' + page, this.getHeaders())
  //     .pipe(
  //       map((response: any) => {
  //         const { status, data } = response;
  //         if (status) {
  //           let courseUnparsed = data
  //           let courseParsed = []
  //           courseUnparsed.forEach(course => {
  //             courseParsed.push(course.Curso)
  //           })
  //           const transformCoursePipe = new TransformCoursePipe();
  //           let courses = transformCoursePipe.transform( courseParsed );
  //           return { valid: true, print: courses };
  //         } else {
  //           return { valid: false, print: data };
  //         }
  //       }),
  //       retry(this.baseRetry),
  //       catchError(this.handleError<any>("getCourses", []))
  //     );
  // }

  public certifications() {
    this.getCertifications().subscribe((certifications) => {
      if (certifications.valid) {
        this.usersInfo.forEach((user, index) => {
          Object.entries(certifications.print).forEach(
            ([user_id, certification]) => {
              //console.log("Training Service: getCertifications - user_id, certification", user_id, certification)
              if (user.User.id == user_id) {
                //console.log("Training Service: getCertifications - certification", certification);
                this.usersInfo[index].Study = certification;
              }
            }
          );
        });
        //console.log("Training Service: Usuarios con certificados: ", this.usersInfo);
      }
    });
  }

  public _managementObservable: Subject<any> = new Subject<any>();
}
